const Store = {
    storeList: () => 'store/associated-stores',
    switchStore: (storeId: string) => `store/switch/${storeId}`,
    searchUser: (userID: string) => `store/search/${userID}`
}
export default Store